<div class="customize-roles" *ngIf="selectedRole">
  <div class="customize-roles--fields">
    <div class="customize-roles--form-field">
      <label for="role-name" class="customize-roles--form-label">{{
        labels.roleName
      }}</label>
      <input
        type="text"
        id="role-name"
        aria-describedby="role-name"
        placeholder="Type Role Name"
        [(ngModel)]="selectedRole.name"
        [disabled]="selectedRole.locked! || !editPermissions?.actions?.includes('EDIT_DETAILS')"
        (keyup)="roleNameValidation(selectedRole.name)"
        maxlength="50"
        autocomplete="off"
        [ngClass]="{
          'customize-roles--form-input-error': !isDuplicateName() || selectedRole.isInvalidText
        }"
      />
      <div class="errorTextField" *ngIf="selectedRole.isInvalidText">
        {{ labels.roleNameValidationError}}
      </div>
      <div class="customize-roles--form-error" *ngIf="!isDuplicateName()">
        {{ labels.duplicateRoleNameErrorText }}
      </div>
    </div>

    <div class="customize-roles--form-field">
      <label for="description" class="customize-roles--form-label">{{
        labels.description
      }}</label>
      <textarea
        [disabled]="selectedRole.locked! || !editPermissions?.actions?.includes('EDIT_DETAILS')"
        class="customize-roles--role-description"
        id="description-mobile"
        aria-describedby="description"
        placeholder="Type description here"
        (change)="onChangingDescription()"
        [(ngModel)]="selectedRole.description"
        maxlength="200"
        #textDescription
        (keyup)="textAreaAutoSize()"
        (focusout)="textAreaAutoSize()"
      ></textarea>
    </div>
  </div>

  <div class="customize-roles--permissions">
    <div class="customize-roles--sub-title">{{ labels.permissionLabel }}</div>

    <div
      class="customize-roles--permission-field"
      *ngFor="let permission of permissionsList || []"
    >
      <div class="customize-roles--permission-field-header">
        <div class="customize-roles--permission-field-header-name">
          {{ permission.sectionHeader }}
        </div>
        <div tabindex="0" *ngIf="!selectedRole.locked">
          <button
            class="btn customize-roles--permission-field-unselect-all"
            (click)="unSelectAll(permission)"
            [disabled]="isAllPermissionFalse(permission)"
           *ngIf = "editPermissions?.actions?.includes('EDIT_DETAILS')"
            aria-describedby="unselect-all"
          >
            {{ labels.unselectAllText }}
          </button>
        </div>
      </div>
<ng-container *ngIf="permission?.permissionArr && permission.permissionArr.length > 0">
      <div
        class="row customize-roles--permission-field-content"
        *ngFor="let value of permission?.permissionArr"
      >
        <div
          class="col-10 col-md-4 col-lg-4 customize-roles--permission-field-name"
        >
          {{ value.permissionShortDescription }}
        </div>
        <div class="col-12 col-md-6 col-lg-7 customize-roles--permission-field-description" [innerHTML]="value.permissionDescription">
        </div>
        <div
          class="col-2 col-md-2 col-lg-1 customize-roles--permission-field-status"
        >
          <div class="form-check form-switch" tabindex="0">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              [value]="setPermissonStatus(value.permissionId)"
              [checked]="setPermissonStatus(value.permissionId)"
              (change)="updatePermissonStatus($event, value.permissionId)"
              [disabled]="selectedRole.locked || !editPermissions?.actions?.includes('EDIT_DETAILS')"
              
            />
          </div>
        </div>
      </div>
    </ng-container>
    </div>
  </div>
</div>

<div class="action-footer" *ngIf="selectedRole">
  <div class="action-footer-container">
    <div class="action-footer-sub-container">
      <kng-button
        #kngButtonComponent
        [state]="saveButtonState"
        (clicked)="saveRole()"
        *ngIf="editPermissions?.actions?.includes('EDIT_DETAILS')"
      >
      </kng-button>
    </div>
  </div>
</div>
